import React, { useEffect, useState } from 'react'
import moment from 'moment'
import {	
	WEIGHT_UNIT,
	SERVICES,
	SHIPPING_TYPE,
	DIMENSION_UNIT,
	getInitLooseItemDetail,
	getInitULDItemDetail,
} from '../../../constants'
import siteLogo from '../../../assets/images/EtihadFlightLogo.png'
import flightIcon from '../../../assets/images/plane-filled.png'
import flightIconFilled from '../../../assets/images/Freighter_Grey.svg'
import downArrow from '../../../assets/images/down-arrow.png'
import upArrow from '../../../assets/images/up-arrow.png'
import plusIcon from '../../../assets/images/plus.svg'
import minusIcon from '../../../assets/images/minus.svg'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import {
	setToSessionStorage,
	getBase64Encoded,
} from '../../../utils/StorageUtils'
import { getBookingFlightDetails, removeDuplicates } from '../../SearchPanel/templateUtils'
import '../../FlightDetailsList/flight-details-list.scss';
import truckIcon from '../../../assets/images/cargo_truck.svg'
import fastTrack from '../../../assets/images/fasttrack.png'
import FlightDetailsPopup from '../../FlightDetails/FlightDetailsPopup'
import './flightItem.scss'
import leftLine from '../../../assets/images/Left line_long.png'
import rightLine from '../../../assets/images/Right line_long.png'
import leftLineShort from '../../../assets/images/Left line_short.png'
import rightLineShort from '../../../assets/images/Right line_short.png'

const FlightItem = ({ destinationAirport, selectedOrigin, selectedDestination, flightDate,showDropoffPickup,searchFormData }) => {
	const [isExpanded, setExpanded] = useState(false)
	const [isFlightDetailsPopupOpen, setIsFlightDetailsPopupOpen] = useState(false);
	const { t,i18n } = useTranslation(['labels']);
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
	

	useEffect(() => {
		setExpanded(false)
	}, [destinationAirport])
	let i18nLang = localStorage.getItem('i18nextLng');
	moment.updateLocale( i18nLang.toString() , {
		weekdays : [ t('COMMON.SUN'), t('COMMON.MON'), t('COMMON.TUE'), t('COMMON.WED'), t('COMMON.THU'), t('COMMON.FRI'), t('COMMON.SAT')
		],
		weekdaysShort : [
			t('COMMON.SUN_SHORT'), t('COMMON.MON_SHORT'), t('COMMON.TUE_SHORT'), t('COMMON.WED_SHORT'), t('COMMON.THU_SHORT'), t('COMMON.FRI_SHORT'), t('COMMON.SAT_SHORT')
		]
	});
	const departureTime = moment(destinationAirport.departureDateTime)
	const departureDate = moment(destinationAirport.departureDateTime,'DD-MMM-YYYY')
	const arrivalTime = moment(destinationAirport.arrivalDateTime)
	const arrivalDate = moment(destinationAirport.arrivalDateTime, 'DD-MMM-YYYY')
	const origin = destinationAirport.origin
	const destination = destinationAirport.destination
	let routes = destinationAirport.flightSegmentList
		? destinationAirport.flightSegmentList.length - 1
		: 0

	let dateFromFlightResponse = destinationAirport?.flightSegmentList?.map((segment) => {
		return segment?.flightDate
	});

	const history = useHistory()

	const getFormatedTime = (value) => {
		let formattedTime = ''
		if (value) {
			let tempArray = value.split(':')
			formattedTime =
				parseInt(tempArray[0], 10) +
				'Hrs ' +
				(tempArray[1] && tempArray[1] != '00' ? tempArray[1] + ' Min' : '')
		}
		return formattedTime
	}

	const getEnglishDate = (value) =>
		value ? value.clone().locale('en').format('ddd DD MMM') : ''

	//Pharma Life && VAC specific state values...
	const [additionalInfoData, setAdditionalInfoData] = useState({
		type: null,
		pharma: {},
	})

	const handleEnquiryBooking = async (e, flightNumber, segmentArray) => {
		e.preventDefault();
		const bookedFlightDetails = await getBookingFlightDetails(
			null,
			flightDate
		)

		let formData = {
			origin: selectedOrigin,
			destination: selectedDestination,
			orginalShipingDate: moment(flightDate,'DD-MMM-YYYY').format('DD-MMM-YYYY'),
			shippingDate:  moment(flightDate,'DD-MMM-YYYY').format('DD-MMM-YYYY'),
			arrivalDate: null,
			shippingItemCode: null,
			shippingType: SHIPPING_TYPE.LOOSE,
			weightUnit: WEIGHT_UNIT.KILOGRAM,
			dimensionUnit: DIMENSION_UNIT.CENTIMETERS,
			shipmentSccs: [],
			appliedSccs: [],
			additionalSccs: [],
			appliedServices: [],
			sccCodes: removeDuplicates([]),
			totalWeight: null,
			totalVolumeInMtrs: 0,
			totalWeightInKg: 0,
			actualGrossWeight: 0,
			shippingType: SHIPPING_TYPE.LOOSE,
			calculatedTotalWeight: 0,
			actualTotalIneItemWeight: 0,
			actualVolume: 0,
			actualChargeableWeight: 0,
			totalPieces: 0,
			looseDetails: [getInitLooseItemDetail()],
			isAllStackable: true,
			isAllTiltable: true,
			ULDDetails: [getInitULDItemDetail()],
			chargeableWeight: 0,
			mixLooseDetails: [getInitLooseItemDetail()],
			expandAccordian: false,
			priceCode: null,
			grossWeightInSelectedUnit: 0,
			grossWeightInConvertedUnit: 0,
			densityInSelectedUnit: 0,
			densityInConvertedUnit: 0,
			chargeableWeightInSelectedUnit: 0,
			additionalInfo: additionalInfoData,
			currency: '',
			bookingFlightDetails: bookedFlightDetails,
			isModifyBooking: false,
			awbNo: '',
		}
		let flightNumberValCombination = segmentArray?.map(segment => {
			return segment?.flightNumber
		})
		let flightDateValCombination = segmentArray?.map(segment => {
			return segment?.flightDate
		})
		let flightParameterObj = {
			flightNumberVal: flightNumber && flightNumberValCombination,
			flightDateVal: flightDate && flightDateValCombination
		}
		setToSessionStorage('flightEnquiryObj', getBase64Encoded(formData))
		setToSessionStorage('flightParameterObj', getBase64Encoded(flightParameterObj))
		history.push('/booking/search');
	}

	const handleSeeDetailsButtonClick = () => {
        setIsFlightDetailsPopupOpen(!isFlightDetailsPopupOpen);
    	};

	

	return (
		<>

		{dateFromFlightResponse[0]?.includes(
        moment(flightDate, "DD-MMM-YYYY")?.format("DD-MMM-YYYY")
      ) && (
	<>
	<div className={`flight-card-routing-enquiry d-none d-lg-flex ${isRTL ? 'rtl' : ''}`}>
					<div className='flight-card-tail-block'>
						<img src={siteLogo} alt='Etihad' title='Etihad' className='flight-card-logo' />
						<div className='flights-list'>
							{destinationAirport.flightSegmentList.length ? (
								destinationAirport.flightSegmentList.map((segment, index) => (
									<div className='flight-list-item' key={index}>
										{segment.flightCarrierCode}
										{segment.flightNumber}
									</div>
								))
							) : (
								<></>
							)}
						</div>
					</div>
					<div className='flight-card-all-content'>
						<div className='flight-card-flight-details'>
							<div className='flight-card-flight-details-top-block'>
								<div className='flight-card-flight-details-top-block-badges'></div>
								<button className='see-details-linkbutton' onClick={handleSeeDetailsButtonClick}>{t('COMMON.SEE_DETAILS')}</button>
							</div>
							<div className='flight-card-flight-details-bottom-block'>
								<div className='flight-card-flight-details-bottom-block-left'>
									<div className='bottom-block-left-time-airport'>
										<div className='bottom-block-left-time'>{departureTime.format("HH:mm")}</div>
										<div className='bottom-block-left-airport'>{origin}</div>
									</div>
									<div className='bottom-block-left-day'>{getEnglishDate(departureDate)}</div>

								</div>
								<div className='flight-card-flight-details-bottom-block-middle'>
									<div className='plane-path'>
										<img src={leftLine} alt='leftLine' className='left-line-long' />

										{/* images */}
										{destinationAirport.flightSegmentList[0].flightType ==
											"T" && (
												<img src={truckIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
											)}
										{destinationAirport.flightSegmentList[0].flightType ==
											"ET" && (
												<img src={truckIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
											)}
										{destinationAirport.flightSegmentList[0].flightType ==
											"IT" && (
												<img src={truckIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
											)}
										{destinationAirport.flightSegmentList[0].flightType ==
											"CO" && (
												<img src={flightIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
											)}
										{destinationAirport.flightSegmentList[0].flightType ==
											"C" && (

												<img
													src={flightIconFilled}
													alt="Flight"
													title="Flight"
													className='plane-path-flight-icon' />

											)}

										<img src={rightLine} alt='rightLine' className='left-line-long' />
									</div>
									{routes ? (
										<div className='duration'>
											<div className='duration-stop'>{routes} {t("COMMON.STOP")}</div>
											<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
										</div>

									) : (
										<div className='duration'>
											<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
										</div>
									)}
								</div>
								<div className='flight-card-flight-details-bottom-block-right'>
									<div className='bottom-block-right-time-airport'>
										<div className='bottom-block-right-time'>{destination}</div>
										<div className='bottom-block-right-airport'>{arrivalTime.format("HH:mm")}</div>
									</div>
									<div className='bottom-block-right-day'>{getEnglishDate(arrivalDate)}</div>

								</div>


							</div>

						</div>
						<div className='vertical-divider-line'></div>
						{destinationAirport.service &&
							destinationAirport.service === SERVICES.FAST_TRACK && (
								<img src={fastTrack} alt="fastTrack" title="fastTrack" className='flight-card-fasttrack' />
							)}
						<button
							type='button'
							className='primary-button flight-card-book'
							onClick={(e) => handleEnquiryBooking(e, destinationAirport?.flightSegmentList[0]?.flightNumber, destinationAirport?.flightSegmentList)}
						>
							{t('COMMON.BOOK')}
						</button>
					</div>
	</div>
	<div className={`d-flex d-lg-none flight-card-routing-enquiry-mobile ${isRTL ? 'rtl' : ''}`}>
			<div className='flight-tail-block-mobile'>
				<img src={siteLogo} alt='Etihad' title='Etihad' className='flight-card-logo-mobile' />
				<div className='flight-list-mobile'>
					{destinationAirport.flightSegmentList.length ? (
						destinationAirport.flightSegmentList.map((segment, index) => (
							<React.Fragment key={index}>
							<div className='flight-list-item-mobile' key={index}>
								{segment.flightCarrierCode}
								{segment.flightNumber}
							</div>
							{index !== destinationAirport.flightSegmentList.length - 1 && (
								<span className='flight-list-item-mobile'>&nbsp;|&nbsp;</span>
								
							)}
							</React.Fragment>
						))
					) : (
						<></>
					)}
				</div>
			</div>
			<div className='flight-deatils-mobile'>
				<div className='top-block-mobile'>
					<div className='flight-card-flight-details-top-block-badges-mobile'></div>
					<button className='see-details-linkbutton' onClick={handleSeeDetailsButtonClick}>{t('COMMON.SEE_DETAILS')}</button>
				</div>
				<div className='bottom-block'>
					<div className='flight-deatils-left-block'>
						<div className='flight-deatils-time'>{departureTime.format("HH:mm")}</div>
						<div className='flight-deatils-airport' >{origin}</div>
						<div className='flight-deatils-day'>{getEnglishDate(departureDate)}</div>
					</div>
					<div className='flight-deatils-middle-block'>
						<div className='plane-path'>
							<img src={leftLineShort} alt='leftLine' className='left-line-short' />

							{/* images */}
							{destinationAirport.flightSegmentList[0].flightType ==
								"T" && (
									<img src={truckIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
								)}
							{destinationAirport.flightSegmentList[0].flightType ==
								"ET" && (
									<img src={truckIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
								)}
							{destinationAirport.flightSegmentList[0].flightType ==
								"IT" && (
									<img src={truckIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
								)}
							{destinationAirport.flightSegmentList[0].flightType ==
								"CO" && (
									<img src={flightIcon} alt="Flight" title="Flight" className='plane-path-flight-icon' />
								)}
							{destinationAirport.flightSegmentList[0].flightType ==
								"C" && (

									<img
										src={flightIconFilled}
										alt="Flight"
										title="Flight"
										className='plane-path-flight-icon' />

								)}

							<img src={rightLineShort} alt='rightLine' className='left-line-short' />
						</div>
						{routes ? (
										<div className='duration'>
											<div className='duration-stop'>{routes} {t("COMMON.STOP")}</div>
											<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
										</div>

									) : (
										<div className='duration'>
											{/* <div className='duration-stop'>Direct</div> */}
											<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
										</div>
									)}
					</div>
					<div className='flight-deatils-right-block'>
						<div className='flight-deatils-time'>{arrivalTime.format("HH:mm")}</div>
						<div className='flight-deatils-airport' >{destination}</div>
						<div className='flight-deatils-day'>{getEnglishDate(arrivalDate)}</div>
					</div>
				</div>
				
			</div>
			<div className='vertical-divider-line'></div>
			{/* <div className='vertical-divider-line'></div> */}
			<div className='pricing'>
				{destinationAirport.service &&
							destinationAirport.service === SERVICES.FAST_TRACK && (
								<img src={fastTrack} alt="fastTrack" title="fastTrack" className='flight-card-fasttrack' />
							)}
				
				<button
							type='button'
							className='primary-button  w-100'
							onClick={(e) => handleEnquiryBooking(e, destinationAirport?.flightSegmentList[0]?.flightNumber, destinationAirport?.flightSegmentList)}
						>
							{t('COMMON.BOOK')}
						</button>

			</div>
		</div>
	{isFlightDetailsPopupOpen && (
		<FlightDetailsPopup
			destinationAirport={destinationAirport}
			searchFormData={searchFormData}
			onClose={handleSeeDetailsButtonClick}
			showDropoffPickup={showDropoffPickup}
			showFooter={false} />
	)}
			</>
      )}
		</>
	
	)
}

export default FlightItem